import React, { useEffect, useState } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import Navbar from "./components/Navbar/Navbar";
import Footer from "./components/Footer/Footer";
import Home from "./pages/Home/Home";
import Gallery from "./pages/Gallery/Gallery";
import About from "./pages/About/About";
import Contact from "./pages/Contact/Contact";
import Stones from "./pages/Stones/Stones";
import styles from "./ App.module.css";
import ScrollToTop from './ScrollToTop';

function App() {
  const location = useLocation();
  const [pageToLoad, setPageToLoad] = useState(null);
  const [stoneType, setStoneType] = useState(null);
  
  useEffect(() => {
    // Parse query parameters
    const queryParams = new URLSearchParams(location.search);
    const pageParam = queryParams.get('page');
    
    if (pageParam) {
      console.log("Page query parameter received:", pageParam);
      
      // Extract stone type if present
      if (pageParam.includes('/stones/')) {
        const type = pageParam.split('/stones/')[1];
        setStoneType(type);
        setPageToLoad('/stones');
      } else {
        setPageToLoad(pageParam);
        setStoneType(null);
      }
    } else {
      setPageToLoad(null);
      setStoneType(null);
    }
  }, [location]);

  // Determine which component to render based on the page parameter
  const renderContent = () => {
    if (!pageToLoad) {
      // No page parameter, use normal routing
      return (
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/stones/*" element={<Stones />} />
        </Routes>
      );
    } else {
      // We have a page parameter, render the appropriate component
      switch (pageToLoad) {
        case '/gallery':
          return <Gallery />;
        case '/about':
          return <About />;
        case '/contact':
          return <Contact />;
        case '/stones':
          return <Stones type={stoneType} />;
        default:
          return <Home />;
      }
    }
  };

  return (
    <div className={styles.app}>
      <ScrollToTop />
      <Navbar />
      {renderContent()}
      <Footer />
    </div>
  );
}

export default App;